export default {
  content: {
    iosPromptPart1: "Install this webapp on your iPhone:<br /> tap ",
    iosPromptPart2: "and then <em>'Add to homescreen.'</em>",
    bookingStatus: {
      statusNew: {
        label: "Pending",
        desc: "Your booking has been sent our way. We just need a little time to review it."
      },
      statusAccept: {
        label: "Approved",
        desc: "Great! Your booking has been reviewed and approved.",
        pickupText: "The driver will wait for you outside the terminal",
        pickupTextDeparture: "We will inform you of the pick up time on %time% around 18:00."
      },
      statusReject: {
        label: "Rejected",
        desc: "Oops! We are truly sorry, but we had to reject your booking.",
        moreInfo: "For more information please",
        contact: "contact us"
      },
      statusCanceled: {
        label: "Cancelled",
        desc: "We have cancelled your booking. Thanks for letting us know!",
        moreInfo: "Your payment has been refunded and should be in your account within 10 business days.",
        infoWithoutRefund: 'You are cancelling less than 8 hours before scheduled flight. You will not be refunded.',
      },
      statusAssigned: {
        descDeparture: "is ready to pick you up tomorrow at",
        descTodayDeparture: "is ready to pick you up today",
        descNormal: "will be waiting for you outside the terminal.",
        contactInfo: "You can contact him on",
        desc: "Meet your driver.",
        label: "Assigned"
      },
      statusCompleted: {
        desc: "We would be super happy if you could",
        review: 'leave a review',
        tripReview: 'Leave a review',
        label: "Complete",
        allDone: "All done!",
        thanksForReview: 'Thanks for the review!',
      },
      statusNoShow: {
        moreInfo: "Tip: If you cancel your booking then the driver will be notified",
        desc: "(<span><strong>%driver%</strong> was waiting for you, but you did not show up.</span>)",
        label: "No show"
      },
    },
    layout: {
      header: {
        welcomeMessage: "Hi! Happy to see you again.",
        registerMessage: "Hello! Have we met before?",
        registerSecondMessage: "No? Let's meet.",
        registerButton: "Register",
        helloAgainTitle: "Hello again!",
        logIn: "Log in",
        activeBookingCount: "<span>You have </span> %count% upcoming booking"
      },
      landingLayout: {
        title: "Affordable & convenient",
        desc: "<span>Your journey to the airport</span> has never been easier!",
        bookNow: "Book now !",
        questionsTitle: "Questions?",
        poweredByStripe: "Powered by Stripe & iZettle®"
      },
      menuMain: {
        home: "Home",
        booking: "Booking",
        howItWorks: "How it works",
        aiportTransfer: "Oslo Gardermoen",
        pricing: "Pricing",
        faq: "FAQ",
        contact: "Contact",
      },
      sidebarAndHeader: {
        dashboard: 'Rides',
        booking: 'Booking',
        myAccount: 'My account',
        help: 'Help',
        editReservation: 'Edit Booking',
        backToEditTitle: 'Back to Edit reservation',
        backToHelpTitle: 'Back to Help',
        backToDashboardTitle: 'Back to Rides',
      }
    },
    landing: {
      homepage: {
        mainpage: {
          title: "Door-to-door",
          subtitleFirst: "Airport Transfers",
          subtitleSecond: "Oslo Torp"
        },
        about: {
          headline: {
            title: "Airport rides made simple",
            description: "Just book, ride and fly!"
          },
          profits: {
            first: {
              title: "Simple booking",
              description: "Tell us where you are flying to and book your airport transfer. You'll get picked up from home, work or the airport - wherever suits you best. The driver will contact you a few minutes before arrival.",
              footer: "Any questions?",
              linkFaq: {
                preTitle: "Check our",
                title: "FAQ"
              },
              linkContact: {
                separator: " or ",
                title: "Contact us"
              }
            },
            second: {
              title: "Punctual driver",
              description: "Your driver will be on time to pick you up. We will arrive at the airport 1,5h before departure. If your arrival flight is delayed, your driver will be waiting for you.",
              footer: "Check status and edit your bookings.",
              linkTitle: "Create an account"
            },
            third: {
              title: "Fixed price",
              description: "We have payment methods that suit your needs. Pay online or directly to the driver. No hidden costs. Always know how much you will pay.",
              footer: "How much will I pay?",
              linkTitle: "Check pricing"
            },
          }
        },
        testimonials: {
          title: "Our happy customers",
          description: "Ride with us and join them",
          items: {
            first: {
              author: "Agnes H.",
              content: "Professional, puncutal and nice driver. I recommend this transfer!",
              logoAlt: "Facebook",
              url: "facebook.com"
            },
            second: {
              author: "Bartholomew O.",
              content: "The day before planned departure I received an SMS with the time of pick up at 16:16. Almost three hours earlier than I was told, so plus for that. As for the trip to the airport, everything went well. Nice driver and zero delays. We were exactly two hours before the scheduled departure.",
              logoAlt: "Facebook",
              url: "facebook.com"
            },
            third: {
              author: "Michaela S.",
              content: "Good, quick, reliable service.",
              logoAlt: "Google",
              url: "google.com"
            },
            fourth: {
              author: "Matthew S.",
              content: "The bus was nice. The driver was professional and contacted us a few minutes before pickup. When arriving to Torp it is impossible not to notice the bus at the airport. I recommend it as a cheaper alternative.",
              logoAlt: "Google",
              url: "google.com"
            }
          },
          footer: {
            title: "Review from"
          }
        }
      },
      howItWorks: {
        title: "How it works",
        description: "Get picked up from home, share the ride and pay less.",
        list: {
          first: {
            title: "Quick booking",
            description: "Just tell us your flight, book your transfer online or by calling us and we will pick you up from home, work or Oslo Torp airport - wherever suits you best."
          },
          second: {
            title: "Always informed",
            description: "If you create an account you can edit and check the status of your booking. If you do not have an account you will receive a confirmation SMS one day before departure. The driver will be contacting you a few minutes before arrival."
          },
          third: {
            title: "Reliable transfer",
            description: "Be sure that your driver will be on time to pick you up. If your arrival flight is delayed your driver will wait for you."
          },
          fourth: {
            title: "Convenient payment",
            description: "Choose the payment method that suits you best. You can pay directly to the driver or online by using credit card."
          }
        }
      },
      transferPage: {
        hero: {
          badge: "PKS Oslo airport transfer",
          title: "Direct ride from Oslo to Gardermoen airport",
          lede: "We pick you up from your door and drive you to the terminal in 40–60 minutes. A fixed price, a small bus and Polish-speaking service guarantee a relaxed start to your journey.",
          kpi: {
            first: "<strong>from 260 NOK</strong> / person – no hidden costs",
            second: "Up to <strong>3 addresses</strong> along the way",
            third: "SMS with confirmation and pickup time"
          },
          cta: "Book a ride",
          hint: "Book at least 3 hours before your flight",
          imgAlt: "PKS Oslo driver in front of the transfer bus"
        },
        benefits: {
          title: "Why do passengers choose PKS Oslo?",
          subtitle: "A service designed for a comfortable ride to Gardermoen.",
          list: {
            first: {
              title: "🏠 Door-to-door pickup",
              description: "The driver comes straight to the address you provide and helps with your luggage. No need to worry about changing transport."
            },
            second: {
              title: "💳 Transparent price",
              description: "A fixed rate <strong>from 260 NOK / person</strong>. You pay for a seat, not for the whole ride like in a taxi."
            },
            third: {
              title: "🧳 Comfortable bus",
              description: "A small bus means up to three passengers along the way and a short travel time, with no crowds or unnecessary stops."
            }
          }
        },
        process: {
          title: "What does the transfer look like?",
          subtitle: "Three simple steps – from booking to check-in.",
          steps: {
            first: "<strong>You book the ride</strong> online in a few minutes and enter your pickup address.",
            second: "<strong>The day before your flight you receive an SMS</strong> with the exact time the driver will arrive. The standard travel time is 40–60 minutes.",
            third: "<strong>The driver picks you up from your door</strong> and takes you directly to Gardermoen airport."
          }
        },
        comparison: {
          title: "PKS Oslo, Flybussen or taxi?",
          subtitle: "Compare the most popular ways to get to the airport.",
          columns: {
            pks: "PKS Oslo",
            flybussen: "Flybussen",
            taxi: "Taxi"
          },
          rows: {
            pickup: {
              label: "Door-to-door pickup",
              pks: "✅ Yes",
              flybussen: "❌ No (bus stop)",
              taxi: "✅ Yes"
            },
            price: {
              label: "Price",
              pks: "<strong>from 260 NOK / person</strong>",
              flybussen: "approx. 260 NOK / person",
              taxi: "~900–1200 NOK per ride"
            },
            duration: {
              label: "Travel time",
              pks: "⏱️ 40–60 min",
              flybussen: "60–90 min",
              taxi: "⏱️ 40–60 min"
            },
            stops: {
              label: "Stops along the way",
              pks: "<strong>Max. 3 addresses</strong>",
              flybussen: "Many stops",
              taxi: "None (private ride)"
            },
            luggage: {
              label: "Luggage",
              pks: "Loading assistance, included",
              flybussen: "Included",
              taxi: "Included"
            },
            language: {
              label: "Service language",
              pks: "Polish",
              flybussen: "NO / EN",
              taxi: "NO / EN"
            }
          },
          disclaimer: "Taxi cost estimates are based on typical rates in Oslo (they may vary depending on the company and time of day)."
        },
        quotes: {
          title: "What do passengers say?",
          first: {
            text: "“The driver arrived on time, the trip was fast and stress-free. Highly recommended!”",
            cite: "— Kasia, Oslo"
          },
          second: {
            text: "“For our family this is the best way to the airport: comfortable and at a great price.”",
            cite: "— Piotr, Drammen"
          }
        },
        info: {
          title: "Transfer Oslo – Gardermoen airport",
          first: "Looking for a convenient ride to Gardermoen airport? PKS Oslo is a proven <strong>transfer from Oslo to the airport</strong> without stress or changing transport. We pick you up from your door and stop at up to three addresses along the way. We run every day, adjusting pickup times to your flight.",
          second: 'The ride usually takes <strong>40–60 minutes</strong>, and booking takes just a few clicks. After placing your order you will receive an SMS confirmation and contact details for the driver. Questions? Call <strong>+47 96 70 11 03</strong> or email <a href="mailto:info@pksoslo.com">info@pksoslo.com</a>.'
        }
      },
      faq: {
        title: "FAQ",
        description: "Here is a list of our most common questions  ",
        generalTitle: "General",
        paymentTitle: "Payment",
        accountTitle: "Account",
        generalQuestions:
          [
            {
              title: 'How do I book the airport transfer?',
              paragraph: 'You can book an airport transfer by using our booking form or call us on <a href="tel:+4796701103">+47 96 70 11 03</a>. Tell us what flight you are going to and where to pick you up to make your booking.'
            },
            {
              title: 'Where can I find you at the airport?',
              paragraph: 'Finding the driver at the airport is easy. The driver will wait for you outside the arrival hall with a blue PKS Oslo sign. Go up to him and he will show you to the minibus. <br /><br />Tip: Remember to turn on your phone after you have landed because the driver might try to contact you!'
            },
            {
              title: 'Do you offer airport transfer service to Gardermoen airport?',
              paragraph: 'We do not offer a shared transfer to Gardermoen / Oslo airport. <br /><br /> If you are a group of 5 or more passengers we can offer you a private transfer. To book a private transfer please contact us at <a href="mailto:info@pksoslo.com">info@pksoslo.com</a>.'
            },
            {
              title: 'I cannot find my flight.',
              paragraph: 'If your flight does not show up in the booking form then it means that we do not drive to that particular flight. However, you can try to find another flight around the same time. We will be at the airport around 1,5 hour before departure.'
            },
            {
              title: 'What time will the minibus pick me up?',
              paragraph: 'We do not have a fixed time schedule because we offer a door-to-door service. The route is planned one day before and you will receive an SMS one day before departure around 18.00 with the time of pick up. <br /><br />If the pick up time does not work for you - no worries. You can always cancel the booking free of charge. If you have paid with card you will be refunded within 10 business days.'
            },
            {
              title: 'Which flights are you going to?',
              paragraph: 'You can find all the flights we drive to in our booking app. If you do not find your flight, then you can try to find another flight that is around the same time.'
            },
            {
              title: 'Can I change the booking to another date?',
              paragraph: 'If you want to change the date of your transfer you can cancel your existing booking and create a new one. If you have paid with card you will get automatically refunded if you cancel your flight 8 hours prior to your flight.'
            },
            {
              title: 'Do you have safety seats for children?',
              paragraph: 'Yes. When you are booking through our booking app then you can choose which kind of safety seat you need. If you are booking through phone then our representative will find a suitable safety seat for you.'
            }
          ]
        ,
        paymentQuestions:
          [
            {
              title: 'Can I pay by credit card?',
              paragraph: 'Yes. You pay with Visa and Mastercard through our app or you can pay directly to the driver.'
            },
            {
              title: 'Can I pay with cash?',
              paragraph: 'Yes. We accept cash payments in Norwegian Crowns (NOK).'
            },
            {
              title: 'Can I get my money refunded?',
              paragraph: 'If you cancel your trip 8 hours before your flight we will refund you the full amount. It can take up to 10 business days before the money is back in your account.'
            },
          ],
        accountQuestions:
          [
            {
              title: 'How do I create an account?',
              paragraph: 'You can create an account using our sign up page. You will need to verify your phone number in order to use your account.'
            },
            {
              title: 'Is it possible to edit my booking?',
              paragraph: 'You can freely edit your booking up until 18.00 one day before your flight. You can change how many passengers are going, pick up address or children safety seats.'
            },
            {
              title: 'How can I cancel my booking?',
              paragraph: 'You can cancel your booking by logging into your account, going to "Trips" and clicking cancel button on your transfer. <br /><br />If you do not have an account you can cancel your transfer by calling us at <a href="tel:+4796701103">+47 96 70 11 03</a> and one of our representatives will cancel the booking for you.'
            },
            {
              title: 'I forgot my password.',
              paragraph: 'You can create a new password by using “I forgot my password” form. You will receive an SMS code on your registered phone number and then you can proceed to creating a new password.'
            },
            {
              title: 'I have a new phone number.',
              paragraph: 'You can change your phone number on the “My account” page when you are logged into your account.'
            },
          ]
      },
      contact: {
        title: "Contact",
        description: "Reach out to us and we'll happily answer your questions.",
        desc: {
          title: "Get in touch!",
          content: "We'd love to hear from you",
          paragraphs: {
            first: {
              title: "Our office works everyday",
              desc: "from 08:00 to 21:00"
            },
            second: {
              title: "What can we do for you?",
              //              desc: "We’re here to help"
            },
            third: {
              title: "Make a Booking",
              desc: "You can book your Oslo Torp airport transfer using our app or by contacting us by phone."
            },
            fourth: {
              title: "Customer Support",
              desc: "Do you have any questions regarding our service? Just contact us and we will gladly answer any question you might have!"
            }
          }
        },
        form: {
          title: "Contact us",
          inputs: {
            name: {
              label: "Name & surname/company",
              placeholder: "Your name"
            },
            email: {
              label: "email",
              placeholder: "Your email"
            },
            message: {
              label: "your message",
              placeholder: "I’d like to tell you..."
            },
            sendButton: "Send",
            sendingButton: 'Sending...'
          }
        }
      },
      pricing: {
        title: "Airport transfer prices",
        desc: "Get the best price for transfers to and from Oslo Torp",
        adults: "adults",
        kids: "kids*",
        info: "*You can buy discounted tickets for children up to 12 years of age.",
        infoPromotion: "**The promotion lasts from 17.08.2023 to 15.01.2024",
        doorToDoor: {
          titleGardermoen: "Door-to-door transfer Oslo Gardermoen",
          title: "Door-to-door transfer Oslo Sandefjord Torp",
          column: "door-to-door",
        },
        busStop: {
          title: "Bus stop Transfer Oslo Sandefjord Torp",
          column: "bus stop",
        }
      },
      termsAndConditions: {
        title: "Terms and Conditions",
        desc: "Rules and regulations that govern the ride with PKS Oslo",
        general: {
          title: "General rules",
          list: [
            { content: "The operator the airport transfer is Flyo AS based in Bekkenstenveien 53B, Oslo hereinafter referred to as “Carrier”." },
            { content: "These terms and conditions define the rules for the sale of tickets, transport of passengers and luggage carried by Flyo AS." },
            { content: 'Document that authorizes the transfer is "SMS confirmation", "Email confirmation" or "Receipt" hereinafter called as “Ticket”.' },
            { content: "Making a booking with Flyo AS constitutes acceptance of the “Terms and conditions”" }
          ]
        },
        booking: {
          title: "Booking Terms",
          list: [
            { content: "Booking for airport transfer can be made using the booking app or by calling the support line. The booking is confirmed when a confirmation email or SMS is received." },
            { content: "There is no need to print the confirmation email. The driver will be informed about all the passengers and will only need name and/or phone number." },
            { content: "Customer data is not shared or sold to third parties and all customer data is stored according to Norwegian law." },
            { content: "Flyo AS is responsible for the performance and quality of the service sold to you." },
            {
              content: "Flyo AS is responsible for the following:",
              list: [
                { content: "credit card transactions made ​​through this website." },
                { content: "informing when the driver will be at the agreed pick up spot one day prior to departure." },
                { content: "informing of any significant changes to bookings." },
              ]
            },
            { content: "The booking becomes binding when it is confirmed by phone or in writing by Flyo AS. Online bookings become binding once a confirmation emails is received." },
            { content: "To cancel or edit a booking please contact PKS Oslo via email: <a href='mailto:info@pksoslo.com'>info@pksoslo.com</a>. It can also be done manually through our booking app." },
            { content: "Cancellation can be made up until 8 hours before scheduled flight with a full refund. A refund will not be made if cancellation is made less than 8 hours before your scheduled flight." },
            { content: "Changing the booking to another date is free of charge if it is made more than 8 hours before scheduled departure." },
            { content: "Editing the passengers, pick up location and children safety seats is possible up until 18.00 one day before departure and is free of charge." },
            { content: "Prices are in Norwegian kroner (NOK). All prices are inclusive of VAT." },
          ]
        },
        carrier: {
          title: "Carrier",
          list: [
            { content: "Carrier is not liable for delays and their further consequences caused by administrative factors (eg police checks), or other factors beyond the control of the Carrier (eg technical problems, weather conditions, traffic jams)." },
            { content: "Carrier will aim to carry the passenger and baggage within reasonable time in accordance with the plan of the journey, but for reasons beyond his control, he can not guarantee this." },
            { content: "Carrier reserves the right to have connecting services during the journey due to logistical reasons or for the security of passengers." },
            { content: "Passengers who are unable to travel due to fault of the Carrier are entitled to a refund amount equivalent to the unused ticket." },
            { content: "Bookings for the minibus is done by placing an order by phone or through the booking app form on <a href='http://www.pksoslo.com'>www.pksoslo.com</a>. Bookings are confirmed at the time of receiving a confirmation email." },
            {
              content: "The carrier has the right not to allow passengers on the bus or refuse further carriage without reimbursement of costs incurred by the Passenger, when the passenger:",
              list: [
                { content: "does not comply with the rules of these regulations," },
                { content: "is influenced by alcohol or drugs" },
                {
                  content: "is in a state or behaves in a manner that could adversely affect the safety or comfort of fellow passengers<br>Legal consequences of these situations are held by the Passenger."
                }
              ]
            },
            { content: "It is not allowed to consume alcoholic beverages, drugs or smoke." },
            { content: "It is only allowed to carry certain pets after previously informing the Carrier. The transported animal must be properly secured, be in a cage and be placed on the seat next to the passenger. Transportation of animals must be done without disturbing other passengers during the journey." },
            { content: "The cost for transportation, taxes, charges and fees for Flyo AS services are non-refundable in the case the of passenger not showing up at agreed meeting spot." },
          ]
        },
        passengers: {
          title: "Passengers",
          list: [
            { content: "Passengers should arrive at the appointed place at the appointed hour. Carrier is not obliged to wait for passengers not complying with this provision." },
            { content: "Passengers are required to comply with police regulations during the journey." },
            { content: "Passengers are responsible for any damage caused to the Carrier (in particular for damage in the bus) and other passengers on general principles stipulated by the Civil Code." },
            { content: "Passengers are required to use seat belts when traveling." },
            { content: "Children under the age of 12, which does not exceed 150cm tall, transported in bus has to use safety seats or other equipment for transporting children, corresponding to the weight and height of the child. The child should stay throughout the trip in a secured protective seat. The passenger needs to notify the Carrier which safety seats to bring when creating the booking." },
            { content: "Carrier is not liable for minors traveling without a legal guardian." },
            { content: "Items left behind on the bus by are not covered by the carrier." }
          ]
        }
      },
      privacyPolicy: {
        title: "Privacy Policy",
        introduction: {
          title: "Introduction",
          list: [
            { content: "<strong>Flyo AS</strong> (“Carrier”) is committed to ensuring that you trust us and how we process your personal information. In this privacy statement, we therefore explain why we collect information about you, how we use this information, and how we take account of your privacy." },
            { content: 'Personal information is information and assessments that can be linked to an identifiable individual. This can be, for example, names and contact information, purchase history or interest information.' },
            { content: "Use of personal data must comply with the Personal Data Act. We, as the controller, will ensure that we use your personal information in accordance with the law." }
          ]
        },
        whatPersonalInformation: {
          title: "What personal information do we have about you?",
          list: [
            { content: "Depending on what information you provide to us, how you use our services, and what permissions you provide to us, we have the following information about you:" },
            { content: '<strong>Information about you:</strong> Information you provide when you create a user account or order tickets, such as name, address, telephone number and email address.' },
            { content: "<strong>Purchase information:</strong> Information we get when you buy tickets from us, such as what you bought, card number and payment method (eg Visa). If you have a user account with us you will get an overview of your previous purchases in your user account." },
            { content: "<strong>Communication:</strong> Information you give us when you contact our customer center, such as emails sent between us." },
            { content: "<strong>Website Usage Information:</strong> Information we get when you use our website and app, such as what kind of device you have (eg mobile or PC), IP address, which pages you visit and what features you use there." },
            { content: "<strong>Profiling Information:</strong> Information and assumptions we automatically create based on the other information (mentioned above) we have about you, such as your preferences and interests and what demographic groups you belong to, unless you have contradicted this." },
          ]
        },
        whatWeUsePersonalInformationFor: {
          title: "What we use personal information for",
          list: [
            { content: "We use your personal information for the following purposes:" },
            { content: '<strong>Website and App:</strong> We use the information to customize our website and app to the technical equipment you use.' },
            { content: "<strong>Execute ticket bookings:</strong> We use the information to complete your ticket purchase, including: to send you the tickets, receive payment and save your purchase history." },
            { content: "<strong>Creating a user account:</strong> We use information if you create a user account, eg. to provide you with username and password, to store your contact information and payment information, and to view your purchase history." },
            { content: "<strong>Customer Service:</strong> We store information that you provide and receive if you contact us to provide service and manage your customer relationship." },
            { content: "<strong>Statistics:</strong> We compile statistics and map market trends to improve and further develop our products and services. As far as possible, we do this with anonymous information, without our knowledge that the information is specifically related to you." },
            { content: "<strong>Marketing:</strong> We use your contact information (eg phone number and email address) to send you recommendations and information about our performances. We may use profiling information to make the recommendations and information most relevant to you, unless you have contradicted this. If you wish, we will also send you recommendations and information about our partners' performances." },
            { content: "The legal basis for Objectives <strong>1</strong>, <strong>4</strong> and <strong>5</strong> is our legitimate interest in providing, developing and marketing our services." },
            { content: "The legal basis for purposes <strong>2</strong>, <strong>3</strong> and <strong>4</strong> is to fulfill our contract with you." },
            { content: "The legal basis for purpose <strong>5</strong> may also be your consent, if you have given us this. It may be necessary to send you marketing if you no longer have a user account with us, or if we send you marketing about our partners' performances." },
          ]
        },
        whoWeSharePersonalInformationWith: {
          title: "Who we share personal information with",
          list: [
            { content: "We share personal information with companies that provide technical and administrative services to us, such as IT providers. We have agreements with these to ensure your privacy." },
            { content: "We may disclose information in individual cases, for example to public authorities, on suspicion of a criminal offense." },
            { content: "If you consent, we may share your personal information with our affiliates as described in your consent. We use IT suppliers inside the EEA." },
            { content: "We can also share anonymous information with partners for, among other things. market analysis and service development." },
          ]
        },
        howLongWeStorePersonalInformation: {
          title: "How long we store personal information",
          list: [
            { content: "We store information about you only as long as it is necessary to achieve the purpose for which it was obtained, or if we are required to store the information. The information will be deleted or anonymized when it is no longer necessary for the purpose. Below is an overview of how long we store your information:" },
            { content: "<strong>Information about you:</strong> If you have a user account with us, you can contact us and we will delete the information we have about you." },
            { content: "<strong>Purchase information:</strong> If you have a user account with us, we will store your purchase history. We store transactions and payment information for 5 years in accordance with the Accounting Act." },
            { content: "<strong>Website Usage Information:</strong> We store information about your use of our website for up to 6 months." },
            { content: "<strong>Partner Information:</strong> We store any affiliate information as long as you have an active user account with us or as long as you consent. We will delete the information if you cancel your user account." },
            { content: "<strong>Communication:</strong> We store communication with our customers for three years, unless we need to store it longer, e.g. in connection with complaints or claims." },
            { content: "<strong>Profiling information:</strong> If you have a user account with us, we will delete the information when you terminate the user account or user account. We will delete the information earlier if you oppose being profiled." },
          ]
        },
        yourRights: {
          title: "Your rights",
          list: [
            { content: "You have the right to ask us to:" },
            {
              list: [
                { content: "Provide you with additional information on how we process your personal information." },
                { content: "Provide you with a copy of personal information about you." },
                { content: "Update your personal information." },
                { content: "Delete information that we no longer have grounds to store." },
                { content: "Restrict or stop the processing of your information." },
                { content: "Oppose automatic individual decisions, including profiling." },
                { content: "Provide you with information that you have provided to us in a structured, commonly used and machine-readable format or, where technically possible, ask us to transfer these to another company." },
                { content: "Withdraw any consent you have given us." },
              ]
            },
            { content: "Please be aware that there are limitations to these rights. Feel free to contact us for more information on this." },
            { content: "If you believe that we process personal data in violation of the Personal Data Act, you have the right to appeal to the Data Inspectorate. Before you do this, we would like you to contact us so that we can answer your questions or resolve any misunderstandings." },
          ]
        },
        cookies: {
          title: "Cookies",
          list: [
            { content: "We use cookies on our website to ensure website functionality, analyze web traffic and see which sites on our site you have visited." },
          ]
        },
        changesToThePrivacyStatement: {
          title: "Changes to the Privacy Statement",
          list: [
            { content: "We may update the Privacy Statement from time to time. You will be notified of significant changes. You will always find the latest version of our privacy statement on the website / app." },
          ]
        },
        contactInformation: {
          title: "Contact information",
          list: [
            { content: "If you want to get in touch with us, you can use the following contact information:" },
          ],
          address: [
            { content: 'Phone number: <a href="tel:4796701103" itemProp="telephone">+47 96 70 11 03</a>' },
            { content: 'Email address: <a href="mailto:info@pksoslo.com" itemProp="email">info@pksoslo.com</a>' },
            { content: 'Address: <span itemProp="streetAddress">Bekkenstenveien 53B</span>,<span itemProp="postalCode">0976</span> <span itemProp="addressLocality">Oslo</span>' },
          ]
        },
      },
    },
    notifications: {
      default: {
        success: "Success"
      },
      contact: {
        error: 'Error',
        cannotBeSent: 'Your email cannot be sent. Try again later.',
        success: 'Message sent!',
        successMessage: 'We will reply shortly.'
      },
      reviews: {
        error: 'Error',
        noComment: 'Please enter a comment',
        success: 'The review has been saved. Thank you!'
      },
      settings: {
        success: "Saved",
        error: "Oops! Can't save. Refresh page and try again."
      },
      invoices: {
        successMessage: "Information has been saved.",
        errorTitle: "Error"
      },
      cards: {
        success: "Card has been added.",
        error: "Error"
      },
      cardItems: {
        success: "Card has been removed.",
        error: "Error",
        errorMessage: "Error while removing card."
      },
      addressItem: {
        success: "Address has been removed.",
        error: "Error",
        errorMessage: "Error while removing address."
      },
      addressComponent: {
        noResults: "No results",
        warning: {
          title: "Warning!",
          addressInvalid: "Addres is invalid.",
          addressInDatabase: "Addres is already saved."
        }
      },
      facebook: {
        error: "Error"
      },
      google: {
        error: "Error"
      },
      loginPage: {
        error: "Error"
      },
      loginForm: {
        success: "You are logged in.",
        error: "Error"
      },
      bookingStep4: {
        error: "Error"
      },
      phoneSmsVerification: {
        success: "Phone number has been changed.",
        error: "Error",
        errorMessage: "Enter whole code."
      },
      phoneNumberVerification: {
        success: "Account has been created and you are logged in.",
        error: "Error",
        invalidMessage: "Enter whole code"
      },
      profileResetPassword: {
        success: "Password has been changed.",
        error: "Error"
      },
      mapPlaces: {
        success: {
          addressInDatabase: "Address is already saved.",
        },
        warning:
        {
          title: "Warning!",
          addressSaved: "Address saved."
        },
        error: "Error",
        errorMessage: "Error while saving address",
      },
      reservationEdit: {
        error: "Error",
        errorSubmit: "Error!",
        warning: {
          title: "Warning!",
          message: "The booking has not been changed."
        }
      },
      suplementSummary: {
        success: "Changes to your booking has been saved.",
        error: "Error"
      },
      notificationButtons: {
        cancelSuccess: "Booking has been cancelled.",
        error: "Error",
      }
    },
    supplementSummary: {
      paySupl: "Pay"
    },
    reservationEdit: {
      address: "Address",
      editAddress: "Edit address",
      passengers: "Passengers",
      adults: "adults",
      kids: "kids",
      students: "students",
      editPassengers: "Edit passengers",
      oldPrice: "Old price",
      changePrice: "Change in price",
      newPrice: "New price",
      payWithCard: "You've chosen to pay with card",
      payDriver: "You've chosen to pay to driver. You will not be charged now.",
      changeDetails: "Change booking details",
      changeNothing: "I don't want to change anything",
      reservationEditPassengers: {
        title: "Passengers",
        desc: "Change of plans? Update the amount of passengers.",
        adults: "adults",
        kids: "kids",
        students: "students",
        kidsSafetyTitle: "Safety Seat",
        tripMessage: "You are going with kids.",
        carSeatsMessage: "Which type of safety seats do you need?",
      }
    },
    form: {
      inputPhoneNumber: "phone number",
      changePhoneNumber: "Change phone number",
      changePassword: "Change password",
      changePhoneAndPassword: "Edit phone number & password",
      changePhoneDescriptionFirst: "New phone number needs to be verified again",
      changePhoneDescriptionSecond: "We'll send you a verification code on SMS.",
      changePhoneSuccessMessage: "The phone number has been changed."
    },
    errors: {
      passengerCount: "Enter correct amount of passengers.",
      childrenSeats: 'Select car seat for kids.',
      card: {
        cardNumber: 'Incorrect card number',
        cardCvc: 'Incorrect CVC',
        date: 'Incorrect date',
        datePast: 'Date must not be in the past'
      },
      contact: {
        email: 'Email is invalid',
        name: 'Name is invalid',
        message: 'Message is not valid',
      },
      auth: {
        loginPage: {
          passwordBlank: 'enter password'
        },
        loginForm: {
          passwordBlank: 'enter password'
        },
        newPassswordAndCode: {
          codeFull: "Enter whole code.",
          codeEmpty: 'Enter code'
        },
        emailForm: {
          emailEmpty: "Email address is required",
          emailInvalid: "Incorrect email address",
          requestError: "An error occurred. Please try again."
        },
        customerBasicValidation: {
          nameToShort: "Minimum 3 characters",
          nameToLong: "Name is too long",
          emailInvalid: "Incorrect email",
          passwordToShort5chars: "Minimum 5 characters",
          passwordToLong: "Password is too long",
        },
        customerAddressValidation: {
          latEmpty: "Lat cannot be empty",
          lngEmpty: "Lng cannot be empty",
          streetEmpty: "Address cannot be empty",
          postCodeEmpty: "Postal code cannot be empty",
          typeEmpty: "Type cannot be empty"
        },
        customerPhoneValidation: {
          exactlyLength: "Phone number must have %size% digits",
          minNumbersPre: "Minimum",
          minNumbersPost: "digits",
          phoneToLong: "Phone number is too long",
          countryCodeEmpty: "Missing country code"
        },
        registrationFormStep1: {
          emailBusy: "Email is already in use"
        }
      }
    },
    auth: {
      loginPage: {
        title: "Hello! Good to see you.",
        subtitle: "Continue with",
        authSeparator: "or",
        passwordLabel: "password",
        forgotPassword: "Forgot your password?",
        logIn: "Log In",
        accountInfo: "Don't have an account?",
        createAccount: "Create one",
      },
      newPassswordAndCode: {
        title: 'Reset password',
        codeTitle: 'We have sent you a 4 digit verification code',
        codeSentTo: 'to',
        newPasswordLabel: "new password",
        backToEmail: "Back to email",
        changePasswordButton: "Change password"
      },
      emailForm: {
        title: "Reset password",
        description: "Enter your email address and we will send you a verification code.",
        emailLabel: "Email address",
        remember: "I remember! ",
        goBack: "Go back",
        resetPasswordButton: "Reset password",
        successMessage: "Password changed successfully"
      },
      registrationForm: {
        title: 'Continue with',
        or: 'or',
        signUpEmail: 'Sign up with email',
        haveAccount: 'Already have an account?',
        logIn: 'Log in'
      },
      registrationFormStep1: {
        header: 'Nice to meet you',
        labels: {
          fullname: "Name & surname",
          email: "email",
          password: "password"
        },
        terms: {
          first: "By continuing, you agree to our",
          second: "Terms of Use",
          and: "and",
          third: "Privacy Policy"
        },
        haveAccount: 'Already have an account?',
        logIn: 'Log in'
      },
      registrationFormStep2: {
        linkTitle: "Edit personal information",
        title: "Almost done",
        description: "Please make sure the phone number is correct.",
        descriptionSms: "We’ll send you a verification code on SMS."
      },
      registrationFormStep3: {
        headerLinkTitle: "Edit email",
        headerTitle: "Enter verification code",
        headerDescription: "We've sent you a 4 digit verification code to %email%",
        wrongQuestion: "Wrong email?",
        change: "Change it",
        changeTitle: "Change email",
        receiveCodeQuestion: "Didn't receive the code?",
        sendAgain: "Send again",
        separator: "or",
        skipTitle: "Skip",
        skip: "continue without account",
        done: "Done"
      }
    },
    userData: {
      backToAddress: "Back to address select",
      backToPersonalData: "Back to Personal Data",
      personalData: "Personal information",
      loginForm: {
        accountInfo: "Don't have account?",
        register: "Register",
        passwordLabel: "password"
      },
      registerForm: {
        accountInfo: "Already have an account?",
        logIn: " Log in",
        labels: {
          fullname: "Name & surname",
          email: "email",
          password: "password"
        },
        createAccount: "Create an account?",
      },
      changePhoneForm: {
        sendCodeInfo: "We’ve sent you a 4 digit verification code to %phone_label% %phone_number%",
        backToPhone: "Back to phone number",
        done: "Done"
      }
    },
    addressItem: {
      deleteTitle: 'Delete address',
      deleteQuestion: 'Are you sure you want to delete this address?',
      confirmButton: 'Yes',
      rejectButton: 'No, keep it',
      deletePlaceTitle: 'Delete place'
    },
    account: {
      editProfileTitle: 'Edit profile',
      menu: {
        myTrips: 'My rides',
        cards: 'My cards',
        places: 'My places',
        invoices: 'Invoices',
        settings: 'Settings'
      },
      card: {
        deleteCard: 'Delete card',
        deleteCardMessage: 'Are you sure you want to delete this card?',
        title: 'My cards',
        stripeTitle: 'Secure Payments by Stripe',
        addNewCardTitle: 'Add new card',
        cardNumberPlaceholder: 'Card Number',
        cardDatePlaceholder: 'MM/YY',
        cardCvcPlaceholder: 'CVC',
        addCardButton: 'Add card',

        removeBtnConfirm: 'Yes',
        removeBtnCancel: 'No, keep it',
        chooseCard: 'choose card',
        emptyCardsList: 'You dont have any saved cards.',
        addNewCardButton: 'Add new card',

        addNewOne: 'add new',
        saveCard: 'Save card',
        invoiceInfo: 'Invoice information',
      },
      places: {
        title: 'My places',
        myPlaces: 'My places',
        list: {
          favPlacesEmpty: 'You don`t have any saved places.',
          addNewAddress: 'Add new address'
        }
      },
      invoices: {
        invoiceInfo: 'Invoice',
        invoiceSave: "Save",
        form: {
          companyNameLabel: 'Company name',
          addressLabel: 'Address',
          taxNumberLabel: 'Tax number',
          checkboxInfo: 'Invoice for each booking',
        },
      },
      settings: {
        title: 'Settings',
        notifications: 'Notifications',
        language: 'Language',
        logout: 'Log out',
        langs: {
          en: 'English',
          no: 'Norsk',
          pl: 'Polski',
          ru: 'Русский'
        }
      }
    },
    login: {
      title: 'Login panel',
      footer: 'footer'
    },
    sessions: {
      login: {
        title: 'Login form',
        email: 'Enter email',
        password: 'Enter password'
      }
    },
    dashboard: {
      myTrips: "My rides",
      filterByDate: 'Choose date',
      getInvoice: 'Download invoice',
      notFoundTrips: "No rides found",
      upcoming: "Upcoming trips",
      payToDriver: 'Pay to driver',
      payWithCard: 'Paid with card',
      notificationButtons: {
        cancelBookingConfirm: "Yes, cancel this booking",
        cancelBookingText: "No, keep it",
        refundInfo: "If you paid with card you will be refunded within 10 business days",
        infoWithoutRefundNotification: "You are cancelling less than 8 hours before scheduled flight. You will not be refunded.",
        editButton: "Edit",
        cancel: "Cancel",
        booking: "Booking",
        cancelBooking: {
          title: "Are you sure you want to cancel this booking",
          message: "%on% from %from% to %to%"
        },
        closeTitle: "Close"
      },
      slider: {
        title: "How was your trip with %driverName%?",
        desc: "on %date% from %from% to %to%",
        content: "How was your trip? We will be happy for your feedback!",
        addReview: "Add review",
        closeReview: "Close review",
        textAreaPlaceholder: "We would love to know more..."
      },
      summary: {
        newPrice: "New price",
        changePrice: "Change in price",
        paySupl: "Pay",
        refund: "Refund",
        oldPrice: "Old price",
        changesSaved: "Your changes has been saved",
        payDriver: "You've chosen to pay to the driver.<br>You can pay with card or cash (NOK).",
        buttonText: "OK"
      }
    },
    invoiceCheckbox: {
      company: "Company is paying?",
      addInvoice: "Add invoice information",
      canceledInfo: "Your invoice request will be cancelled",
      fillTheForm: {
        first: "Please",
        last: " fill the whole form"
      },
      issueInvoice: "Issue an invoice to ",
      changeInfo: "Need to change invoice info?"
    },
    flyOut: 'Fly out',
    flyBack: 'Fly back',
    common: {
      success: "Saved",
      error: "Error",
      terms: "Terms &amp;&nbsp;Conditions",
      privacyPolicy: "Privacy Policy",
      logIn: "Log in",
      signUp: "Sign up",
      bookNow: "Book now",
      nothingInfo: "There’s nothing here",
      nothingMessage: "Your bookings will be available here.",
      previous: "Previous",
      loggedInError: "You must be logged in",
      loggedInMessage: "Lorem ipsum dolor sit amet conscentetur adipiscing elit lorem ipsum dolor",
      skipToLogin: "Go to Login",
      somethingWrong: "Oops! Something went wrong.",
      optional: 'optional',
      adults: 'adults',
      kids: 'kids',
      under: 'under',
      students: 'students',
      step: 'step',
      next: 'Next',
      price: 'price',
      currency: 'nok',
      backToBooking: 'Back to Booking',
      backToLogin: 'Back to Login',
      backToProfile: 'Back to Profile',
      ok: 'Ok',
      signUpWithEmail: 'Sign up with email',
      close: 'Close',
      show: 'Show',
      hide: 'Hide',
      back: 'Back',
      save: 'Save',
      inputs: {
        oldPassword: 'old password',
        newPassword: 'new password'
      },
      contact: {
        phone: "(+47) 96 70 11 03",
        phoneTitle: "Call us",
        email: "info@pksoslo.com",
        emailTitle: "Send us email"
      }
    },
    calendar: {
      oneWay: 'One way',
      confirm: 'Ok'
    },
    bookingStep1: {
      mobile: {
        selectDate: 'Select dates',
        selectDates: 'Select Date',
        selectAirportLabel: 'Select Airport',
        selectAirportTitle: 'Choose airport',
      },
      headerChooseAirport: 'Choose airport',
      header: 'Book Airport Transfer',
      whatFlight: 'What flight are you going to?',
      chooseAirport: {
        listEmpty: 'No airports found, try again.',
        from: 'Choose airport from',
        to: 'Choose airport to',
      },
      chooseAirportPlaceholder: 'Choose airport...',
      chooseAirportFrom: 'From',
      chooseAirportTo: 'To',
      chooseSelectDate: 'Select date',
      chooseSelectDatePlaceholder: 'View calendar',
      letsGo: 'Let\'s go',
      errors: {
        date: 'Date required',
        passengers: 'Select passengers',
        place: 'Choose location',
        location_same: 'Locations cannot be the same',
        two_airports: 'You cannot select two airports',
        two_cities: 'You cannot select two cities'
      }
    },
    kidsSafety: {
      labels: {
        firstAge: '0-15 months',
        firstWeight: '0-13kg',
        secondAge: '1-4 years',
        secondWeight: '9-18kg',
        thirdAge: '4-12 years',
        thirdWeight: '15-36kg',
        fourthAge: '4+ years',
        fourthWeight: '15-36kg',
      },
      title: 'Safety Seats',
      tripWithCount: 'You are going with ',
      tripWithCountSufix: ' kid(s).',
      typeOfSeatsQuestion: 'Which type of safety seats do you need?',
      safetyList: {
        chooseTitle: 'You must choose ',
        chooseTitleSufix: ' more',
        items: {
          cradle: 'Baby seat',
          seatWithSeatBelts: 'Seat with harness',
          seatWithoutSeatBelts: 'Booster seat',
          carSeatPad: 'Booster cushion',
          noNeedCarSeat: 'I don\'t need a seat'
        }
      }
    },
    bookingStep2: {
      chooseFlyOut: 'Fly out',
      chooseFlyBack: 'Fly back',
      editKids: 'Edit Safety Seats',
      errors: {
        flight: {
          departure: 'You have to choose a flight',
          return: 'You have to choose a flight'
        }
      }
    },
    // map
    bookingStep3: {
      map: {
        backToSelectFlight: 'Back to Flight Selection',
        addAddress: {
          first: 'Add ',
          second: ' different ',
          third: ' return address'
        },
        removeReturnAddress: 'Remove return address',
        addToFav: "Add to favourites"
      },
      address: {
        inputPlaceholder: 'Enter home address or choose bus stop'
      },
      favButton: 'Add to favourites',
      favSpotButton: 'Save as:',
      spots: {
        home: 'Home',
        work: 'Work',
        other: 'Other'
      },
      summary: {
        from: 'from',
        to: 'to',
        totalPrice: 'Total price:',
        smsInfoFirst: 'We will send you a SMS with the time',
        smsInfoSecond: 'of pick up one day before departure.',
        tooltip: {
          button: 'More about pick up',
          departures: 'Departure: You will receive an SMS one day before departure around 18.00 with the time of pick up.',
          arrivals: 'Arrival: Your driver will be waiting for you outside the terminal..',
        }
      },
      errors: {
        postCode: 'Missing postal code.',
        street: 'Missing house number.',
        coords: 'Coordinates not found for the selected address.',
        addressNotFound: 'Address not found.',
        connection: 'Failed connection with the server.', // general info when something is wrong with connection ...
        addressNotSupported: 'Sorry! We do not drive to this address.',
        selectAddress: 'Please select address.'
      }
    },
    //summary
    bookingStep4: {
      stepHeader: {
        title: 'Booking summary',
        linkTitleAddressSelection: 'Back to address select',
        linkTitleUserSelection: 'Back to user selection'
      },
      summary: {
        title: 'Summary',
        totalPrice: 'Total price',
        bookNow: 'Book',
        payToDriver: 'Pay to driver',
        payUsingCard: 'Pay using card',
        passengerData: 'Passenger details:',
        phoneFormat: 'Format: +XXXXXXXXX'
      },
      address: {
        return: 'Return: ',
        departure: 'Departure: '
      },
      errors: {
        payment: {
          emptyData: 'Missing data. Complete the booking process to continue',
          selectPaymentMethod: 'Choose payment method',
          cardDetails: 'Enter payment card details',
          paymentFailed: 'There was an error during the payment'
        },

        map: {
          addressNotSupported: ' Sorry! We do not drive to this address.',
          addressEmpty: 'No address selected',
          addressPostalCode: 'This address does not have a postal code',
          streetNumber: 'Enter house number',
          streetCoords: 'Coordinates not found for the selected address',
        }
      }
    },
    bookingStepFinal: {
      title: 'Thank you for riding with us',
      info: {
        first: 'Your booking has been sent.',
        second: 'You can edit your booking until 18.00 one day before departure.',
        third: 'If there are any questions do not hesitate to contact us.'
      },
      confirm: 'Ok'

    },
    homepage: {
      title: 'AIRPORT RIDES MADE SIMPLE',
      content: `Select a flight to or from Oslo Sandefjord Torp Airport,
       and then book your bus by phone or website.
       We will pick you up from home, work or airport and receive the day before departure
       SMS with confirmation of bus arrival time.
       We will also call for a moment before appearing at the address indicated.`
    },
    prices: {
      title: 'Airport transfer prices',
      content: 'Reliable Oslo Torp transfers at affordable prices'
    },
    help: {
      header: 'Help',
      question: 'Do you have any questions regarding our service?',
      checkLink: 'Check the links below or contact us.',
      officeWorks: 'Our office works everyday from 08:00 to 21:00.',
      rightsReserved: '© 2019 Flyo AS. All rights reserved.'
    }
  },
  routes: {
    url: {
      booking: '/:locale/booking',
      kidsSafety: '/:locale/booking/kids-safety',
      flights: '/:locale/booking/flight',
      map: '/:locale/booking/map',
      transferPage: '/:locale/transfer-oslo-gardermoen',
      aiportTransfer: '/:locale/transfer-oslo-gardermoen',
      userData: '/:locale/booking/user-data',
      confirmPhone: '/:locale/booking/confirm-phone',
      summary: '/:locale/booking/summary',
      confirmed: '/:locale/booking/confirmed',
      signup: '/:locale/signup',
      registrationStep1: '/:locale/registration-step-1',
      registrationStep2: '/:locale/registration-step-2',
      registrationStep3: '/:locale/registration-step-3',
      login: '/:locale/login',
      resetPassword: '/:locale/reset-password',
      dashboard: '/:locale/dashboard',
      dashboardEdit: '/:locale/dashboard/edit/:id',
      dashboardReservationPayment: '/:locale/dashboard/reservation-payment',
      help: '/:locale/help',
      accountTrips: '/:locale/account/my-trips',
      account: '/:locale/account',
      accountProfile: '/:locale/account/profile',
      accountCards: '/:locale/account/cards',
      accountPlaces: '/:locale/account/places',
      accountPlacesMap: '/:locale/account/map',
      accountInvoices: '/:locale/account/invoices',
      accountSettings: '/:locale/account/settings',

      home: '/',
      howItWorks: '/:locale/how-it-works',
      prices: '/:locale/pricing',
      faq: '/:locale/faq',
      contact: '/:locale/contact',
      termsAndConditions: '/:locale/terms',
      privacyPolicy: '/:locale/privacy-policy',
    },
    name: {
    }
  },
  test: { test: "hello" },
  errors: {
    notFound: {
      title: "404",
      content: "Oops! We could not find the site you were looking for."
    }
  }
}
